(function () {
	"use strict";

	var ENDPOINT = "https://a.klaviyo.com/client/subscriptions/?company_id=UK8HFs";
	var LIST_ID = "SZUkqc";
	var REVISION = "2024-10-15";

	function buildBanner(status, message) {
		var banner = document.createElement("div");
		banner.className = "banner banner--" + status;
		banner.textContent = message;
		return banner;
	}

	function showError(form, submitButton) {
		var existing = form.querySelector("[data-klaviyo-error]");
		if (existing) existing.remove();

		var banner = buildBanner("error", form.dataset.errorMessage);
		banner.setAttribute("data-klaviyo-error", "");
		form.prepend(banner);

		if (submitButton) submitButton.disabled = false;
	}

	function showSuccess(form) {
		form.innerHTML = "";
		form.appendChild(buildBanner("success", form.dataset.successMessage));

		if (form.hasAttribute("data-set-popup-filled")) {
			localStorage.setItem("theme:popup-filled", "true");
		}
	}

	function handleSubmit(event) {
		var form = event.target.closest("form[data-klaviyo-newsletter]");
		if (!form) return;

		event.preventDefault();

		var emailInput = form.querySelector('input[type="email"]');
		var email = emailInput ? emailInput.value.trim() : "";
		if (!email) return;

		var submitButton = form.querySelector('[type="submit"]');
		if (submitButton) submitButton.disabled = true;

		fetch(ENDPOINT, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				revision: REVISION,
				Accept: "application/vnd.api+json"
			},
			body: JSON.stringify({
				data: {
					type: "subscription",
					attributes: {
						profile: { data: { type: "profile", attributes: { email: email } } },
						custom_source: form.dataset.source || "Newsletter"
					},
					relationships: {
						list: { data: { type: "list", id: LIST_ID } }
					}
				}
			})
		})
			.then(function (response) {
				if (response.status === 202) {
					showSuccess(form);
				} else {
					showError(form, submitButton);
				}
			})
			.catch(function () {
				showError(form, submitButton);
			});
	}

	document.addEventListener("submit", handleSubmit);
})();
